import { ApplicationConstants } from '../../shared/applicationConstants';
import { SharedService } from '../../shared/services/sharedService';

export class RegistreService {
    
        static registre(form, lang) {
            lang = lang || ApplicationConstants.defaultLanguageCode;
            form.username = form.email;
            let data = {
                cn: form.name, 
                sn: form.surname, 
                uid: form.username, 
                userPassword: form.pass, 
                email: form.email, 
                tipusEntitatId: "1", 
                ambitGeo: "1", 
                bbox: "260383,4491989,527495,4748184", 
                lang: lang
            };
            return this.registreUser(data);
        }
        static httpPostRegistre(data){
            return SharedService.httpPost(ApplicationConstants.postRegistreUrl, data).then((response) => {
                if (response && response.body) {
                    if (response.body.status === "ERROR") {
                        throw "Error";
                    }
                    else {
                        return response.body;
                    }
                }
            });
        }
        static httpPostValidateEmail(email){
            return SharedService.httpPost(ApplicationConstants.validateEmailUrl, {email: email}).then((response) => {
                if (response && response.body) {
                    if (response.body.status === "ERROR") {
                        throw "Error";
                    }
                    else {
                        return response.body;
                    }
                }
            });
        }
        static httpPostValidateUsername(username){
            return SharedService.httpPost(ApplicationConstants.validateUsernameUrl, {uid: username}).then((response) => {
                if (response && response.body) {
                    if (response.body.status === "ERROR") {
                        throw "Error";
                    }
                    else {
                        return response.body;
                    }
                }
            });
        }

        static async validateUser(username, email){
            let usernameOk = await this.httpPostValidateUsername(username);
            let emailOk = await this.httpPostValidateEmail(email);
            let result = false;
            if("OK" === usernameOk.status && "OK" === emailOk.status){
                result = true;
            }
            return result;
        }

        static async registreUser(data){
            let userValid = await this.validateUser(data.uid, data.email);
            let registreResult = await this.httpPostRegistre(data);
            //let registreResult = {status: "OK"};
            let result = false;
            if(userValid && "OK" === registreResult.status){
                result = true;
            }
            return result;
        }

        static httpPostSendMail(data){
            return SharedService.httpPost(ApplicationConstants.sendMailUrl, data).then((response) => {
                if (response && response.body) {
                    if (response.body.status === "ERROR") {
                        throw "Error";
                    }
                    else {
                        return response.body;
                    }
                }
            });
        }

        static async sendMailRegistre(email, subject, contingut){

            var data = {
                uid: email,
                to: email,
                subject: subject,
                content: contingut
            };
           await this.httpPostSendMail(data);
        }
    }



// WEBPACK FOOTER //
// ./src/registre/services/registreService.js